import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { VideoTeaserComponent } from "../video-teaser.component";
@Component({
  selector: 'div.news-item',
  templateUrl: './video-teaser-newsblock.component.html',
  styleUrls: ['../video-teaser-share.scss','./video-teaser-newsblock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class VideoTeaserNewsblockComponent extends VideoTeaserComponent implements OnInit {


  // refactorLastUpdate() {
  //   const value = this.video.lastUpdate;
  //   if (value) {
  //     if (value.includes('更新到')) {
  //       return '<span class="mr-1">更新</span>' + '<span class="text-red"><b>' + this.video.lastUpdate.replace('更新到', '') + '</b></span>';
  //     }
  //     return '<span>' + this.video.lastUpdate + '</span>';
  //   }
  //   return "";
  // }

 
}
